import { styled } from '@mui/material/styles';
import { OcrWordRoot } from '@/pages/document/DocumentViewer/DocumentFileView/PageView/PageOcrLayer/OcrWords/OcrWord/StyledComponents';

export const GrabbedOcrWordFrame = styled(OcrWordRoot, { label: 'GrabbedOcrWordFrame' })(() => ({
  opacity: 1,
  pointerEvents: 'none',
}));
